import React from "react";
import type { BaseProvinceIconProps } from "./BaseProvinceIcon";

export const ManitobaIcon = (props: BaseProvinceIconProps) => {
  return (
    <path
      id="MB"
      {...props}
      d="M158,182.8c0.7,0,1.2,0.5,1.1,1.2c-0.2,1.3-0.4,2.5-0.7,3.7c-0.3,1.3,0.9,2.9,0.9,3l6.8,9.9
        c0.1,0.1,1.2,1.6,2.7,1.6c0.1,0,0.2,0,0.4,0c0.9-0.2,1.9-0.4,2.9-0.4c0.8,0,1.6,0.2,2.4,0.7c0.6,0.4,0.4,0.9,0.1,1.5
        c-0.4,0.6-0.8,1.2-1.2,1.8c-0.8,1.2-1.5,2.3-2.3,3.5c-3.7,5.7-7.3,11.5-11.2,17c-2,2.8-2.5,5.6-2,8.9c1.3,9.4,2.4,18.9,3.6,28.3
        c0.2,1.3-0.2,1.6-1.3,1.6c-1.2,0-2.3,0-3.4,0c-0.2,0-0.4,0-0.6,0c-6.7,0.1-13.5,0.2-20.2,0.4c-1.3,0-1.6-0.4-1.6-1.6
        c0.3-24.1,0.8-70.5,0.9-77.8c0-0.6,0.4-1,1-1.1C143.4,184.2,150.5,183.5,158,182.8L158,182.8z"
    />
  );
};
